export interface Notification {
  id?: string,
  uid?: string,
  text: string,
  read: boolean,
}

export abstract class NotificationData {

  abstract getNotifications();
  abstract editNotification(id: string, notification: Notification);
}
